export default class {
	static capitalizeFirstLetter(string) {
		if (string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		} else {
			return null;
		}
	}

	static toCamelCase(key, value) {
		if (value && typeof value === "object") {
			for (var k in value) {
				if (/^[A-Z]/.test(k) && Object.hasOwnProperty.call(value, k)) {
					value[k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
					delete value[k];
				}
			}
		}
		return value;
	}

	/**
	 * ACROText -> ACRO Text
	 * 
		UserNameTest -> User Name Test
	 * @param {string} string 
	 */
	static insertSpaces(string) {
		string = string.replace(/([a-z])([A-Z])/g, "$1 $2");
		string = string.replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
		return string;
	}

	static operator(operator) {
		switch (operator) {
			case "gt":
				return "Greater Than";
			case "gte":
				return "Greater Than or Equal";
			case "lt":
				return "Less Than";
			case "lte":
				return "Less Than or Equal";
			case "eq":
				return "Equal";
			case "neq":
				return "Not Equal";
			case "range":
				return "Range";
			default:
				return "";
		}
	}

	static copyTextToClipboard(text) {
		if (!navigator.clipboard) {
			fallbackCopyTextToClipboard(text);
			return;
		}
		navigator.clipboard.writeText(text).then(
			function() {
				console.log("Async: Copying to clipboard was successful!");
			},
			function(err) {
				console.error("Async: Could not copy text: ", err);
			}
		);
	}
}

function fallbackCopyTextToClipboard(text) {
	var textArea = document.createElement("textarea");
	textArea.value = text;
	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();

	try {
		var successful = document.execCommand("copy");
		var msg = successful ? "successful" : "unsuccessful";
		console.log("Fallback: Copying text command was " + msg);
	} catch (err) {
		console.error("Fallback: Oops, unable to copy", err);
	}

	document.body.removeChild(textArea);
}



// WEBPACK FOOTER //
// ./src/utils/string.js